import React, { useState, useEffect } from 'react';
import { useIntl } from 'umi';
import { useRequest } from 'ahooks';
import { Button, Form } from 'tea-component';
import Abnormal from '@/pages/intelligence/components/Abnormal';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import ExpandCollapseText from '@/pages/intelligence/components/ExpandCollapse';
import MoreModal from '../../../../../MoreModal';
import { fetchCompanyDetailsSummaryAbout } from '@/pages/intelligence/services/companies';
import { PLACEHOLDER } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import './index.scss';
import { COMBINEID_REG } from '@intelligence/utils/constant';
import type { ICompaniesDetailsPageBaseProps } from '../../../types';

const About: React.FC<ICompaniesDetailsPageBaseProps> = (props) => {
  const { companyId } = props;

  const { formatMessage } = useIntl();

  const [visible, setVisible] = useState(false);

  const { loading, data, run } = useRequest(fetchCompanyDetailsSummaryAbout, { manual: true });

  const companyDetails = data?.companyDetails;

  useEffect(() => {
    if (!companyId) return;
    if (!COMBINEID_REG.test(companyId)) return; // 添加ID校验规则
    run({ company_id: companyId });
  }, [companyId]);

  return (
    <CardSlot
      title={formatMessage({ id: 'dbi_company_about' })}
      className="context-card"
      iconList={[]}
    >
      <Abnormal
        isLoading={loading}
        isNoData={!loading && !companyDetails}
        component={
          <Form readonly className="about-box">
            <Form.Item label={formatMessage({ id: 'dbi_company_employee' })}>
              <Form.Text>{companyDetails?.employee || PLACEHOLDER}</Form.Text>
            </Form.Item>
            <Form.Item label={formatMessage({ id: 'dbi_company_founded_date' })}>
              <Form.Text>{companyDetails?.foundedDate || PLACEHOLDER}</Form.Text>
            </Form.Item>
            <Form.Item label={formatMessage({ id: 'dbi_company_last_funding_type' })}>
              <Form.Text>{companyDetails?.lastFundingType || PLACEHOLDER}</Form.Text>
            </Form.Item>
            <Form.Item label={formatMessage({ id: 'dbi_company_ipo_status' })}>
              <Form.Text>{companyDetails?.ipoStatus || PLACEHOLDER}</Form.Text>
            </Form.Item>
            <Form.Item label={formatMessage({ id: 'dbi_company_also_known_as' })}>
              <Form.Text>
                {companyDetails?.alsoKnownAs?.replaceAll('<SEP>', ',') || PLACEHOLDER}
              </Form.Text>
            </Form.Item>
            <Form.Item label={formatMessage({ id: 'dbi_company_website' })}>
              <Form.Text>
                <Button
                  type="link"
                  onClick={() => {
                    window.open(companyDetails?.website);
                  }}
                >
                  {companyDetails?.website || PLACEHOLDER}
                </Button>
                <ExpandCollapseText
                  // className="dbi-text-more"
                  text={companyDetails?.description || PLACEHOLDER}
                  onClick={() => {
                    setVisible(true);
                  }}
                  otherText={formatMessage({ id: 'dbi_more' })}
                />
              </Form.Text>
            </Form.Item>
          </Form>
        }
      />
      <MoreModal
        lang="original"
        title={formatMessage({ id: 'dbi_company_about' })}
        showBottomBtns={false}
        data={{ content: companyDetails?.description }}
        visible={visible}
        close={() => setVisible(false)}
      />
    </CardSlot>
  );
};

export default About;
